import { rootApi } from "../../api/rootApi";

export const approvalWorkflowApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    createApprovalWorkflow: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/approval-workflow/add`,
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.data,
      }),
    }),
    getAllApprovalWorkflows: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/approval-workflow/`,
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
    getApprovalWorkflowById: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/approval-workflow/${params.id}`,
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
    getApprovalWorkflowByEntityType: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/approval-workflow/entity/${params.entity_type}`,
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
    updateApprovalWorkflow: builder.mutation({
      query: (params) => ({
        method: "PATCH",
        url: `/tenant/approval-workflow/${params.id}`,
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.data,
      }),
    }),
    deleteApprovalWorkflow: builder.mutation({
      query: (params) => ({
        method: "DELETE",
        url: `/tenant/approval-workflow/${params.id}`,
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
  }),
});

export const {
  useCreateApprovalWorkflowMutation,
  useGetAllApprovalWorkflowsMutation,
  useGetApprovalWorkflowByIdMutation,
  useGetApprovalWorkflowByEntityTypeMutation,
  useUpdateApprovalWorkflowMutation,
  useDeleteApprovalWorkflowMutation,
} = approvalWorkflowApi;
